import React, { ComponentProps, FunctionComponent } from "react";

const UserMicrophoneIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 13 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M5.12327 0C6.71307 0 8.00517 1.33128 8.00517 2.97081C8.00517 4.61109 6.71443 5.94162 5.12327 5.94162C3.53348 5.94162 2.24137 4.60961 2.24137 2.97081C2.24137 1.33269 3.53421 0 5.12327 0ZM7.97505 9.34435V9.43749L13 7.72357V15.3286L7.63189 13.4977L7.54645 13.5389L8.0493 15.4715L6.13592 16L5.46778 13.4254H4.09651V9.62794H5.20796V9.34494H7.97583L7.97505 9.34435ZM7.24249 12.8517V10.0995H5.93985V12.1109H5.20729V10.3826H4.82769V12.6697H5.73465L6.15065 13.1476L6.65211 15.0768L7.15287 14.9382L6.68083 13.1218L7.24249 12.8517ZM7.97505 10.2324V12.8192L12.2681 14.284V8.76823L7.97505 10.2324ZM9.263 8.70042L8.39246 8.99787C7.84338 6.74176 2.36241 6.9057 1.88138 8.8838L0.931696 12.7881C0.797229 13.3491 1.5347 13.7678 2.00743 13.7678H5.27104L5.51617 14.7122H2.00747C0.938043 14.7122 -0.245483 13.7556 0.0444282 12.5594L0.994107 8.65503C1.71828 5.67627 8.51799 5.63229 9.26241 8.70051L9.263 8.70042ZM5.1232 0.944416C4.03486 0.944416 3.15729 1.84902 3.15729 2.97098C3.15729 4.09217 4.03552 4.99754 5.1232 4.99754C6.20944 4.99754 7.08911 4.09077 7.08911 2.97098C7.08911 1.8505 6.21018 0.944416 5.1232 0.944416Z",
      fill: "currentColor",
      strokeWidth: 1.5,
    })
  );
};

const ForwardRef = React.forwardRef(UserMicrophoneIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
